import React, {useState} from 'react';
import UserManager, {useUserData} from "../../../managers/userManager/userManager";
import AddressShowBox from "../../../checkout/components/shipping/AddressShowBox";
import {ClearOutlined, EditOutlined} from "@mui/icons-material";
import {CardContent, Modal, Paper} from "@mui/material";
import Button from "@mui/material/Button";
import {Trans} from "react-i18next";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import UserInfo, {validateInvoiceData} from "../../../checkout/components/billingData/UserInfo";
import InvoiceDataEditor from "../../../checkout/components/billingData/InvoiceDataEditor";

function MyBillingInfo(props) {
    const userData = useUserData();
    const [open, setOpen] = useState(false);
    const [invoiceData, setInvoiceData] = useState({});
    const [dataFormValidity, setDataFormValidity] = useState({});

    const getControls = () => {
        return (<>
            <EditOutlined sx={{cursor: 'pointer', color: 'text.secondary'}} onClick={openEditModal}/>
        </>);
    }

    const openEditModal = () => {
        setInvoiceData({...userData?.cart?.invoiceData});
        setOpen(true);
    }

    const closeEditModal = () => {
        setOpen(false);
    }

    const handleSubmit = () => {
        if (invoiceDataIsValid()) {
            UserManager.setInvoiceData(invoiceData);
            closeEditModal();
        }
    }

    const invoiceDataIsValid = () => {
        const validity = validateInvoiceData(invoiceData, true);
        setDataFormValidity(validity);
        return Object.keys(validity).length === 0;
    }

    return (userData?.cart?.invoiceData?.userInfo &&
        <div className="mybillinginfo">
            <AddressShowBox address={userData.cart.invoiceData.userInfo}
                            showFirmData={userData.cart.invoiceData.type !== UserInfo.types.NATURAL_PERSON}
                            rightTopCornerBoxContent={getControls()}/>
            <Modal
                open={open}
                onClose={closeEditModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
            >
                <Paper sx={{width: {xs: '100%', sm: 500}, maxHeight: '100%', overflowY: 'auto', overflowX: 'hidden'}}>
                    <IconButton onClick={closeEditModal}
                                sx={{position: 'absolute', top: -5, right: -5, zIndex: 100}}>
                        <ClearOutlined/>
                    </IconButton>
                    <CardContent>
                        <InvoiceDataEditor invoiceData={invoiceData}
                                           setInvoiceData={setInvoiceData}
                                           dataFormValidity={dataFormValidity}
                                           setDataFormValidity={setDataFormValidity}/>
                        <Box sx={{justifyContent: 'flex-end', display: 'flex', pt: 3}}>
                            <Button variant={'contained'} onClick={handleSubmit}>
                                <Trans i18nKey={'buttons.submit'}/>
                            </Button>
                        </Box>
                    </CardContent>
                </Paper>
            </Modal>
        </div>
    );
}

export default MyBillingInfo;
